import * as React from 'react'
import { MarketingLayout } from '../components/marketing-layout'
import { MarketingPageContainer, PageTitle, PageSubtitle, MarketingSection } from '../styles/marketing.styles'

export const PrivacyPage: React.FC = () => {
  return (
  <MarketingLayout>
    <MarketingPageContainer>
      <MarketingSection>
        <PageTitle>Privacy Policy</PageTitle>
        <PageSubtitle>Last updated: March 1, 2026</PageSubtitle>
      </MarketingSection>
      <MarketingSection>
        <h2>Introduction</h2>
        <p>Equa (&ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) is committed to protecting the privacy of our users. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use the Equa platform, including our website and related services. By using the platform, you consent to the data practices described in this policy.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Information we collect</h2>
        <p><strong>Account information:</strong> When you register, we collect your name, email address, and password. If you register via Google, we receive your name, email, and profile picture from Google.</p>
        <p><strong>Organization data:</strong> When you create or join an organization, we collect organization name, structure details, cap table data, member information, and documents you upload.</p>
        <p><strong>Usage data:</strong> We automatically collect information about how you interact with the platform, including pages visited, features used, browser type, device information, and IP address.</p>
        <p><strong>Payment information:</strong> If you subscribe to a paid plan, payment processing is handled by our third-party payment provider. We do not store full credit card numbers on our servers.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>How we use your information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide, operate, and maintain the Equa platform</li>
          <li>Process your registration and manage your account</li>
          <li>Facilitate cap table management, equity tracking, and related organizational features</li>
          <li>Send you service-related communications, such as account verification, security alerts, and support messages</li>
          <li>Analyze usage trends to improve the platform</li>
          <li>Comply with legal obligations</li>
        </ul>
      </MarketingSection>
      <MarketingSection>
        <h2>Data sharing and disclosure</h2>
        <p>We do not sell your personal data. We may share your information in the following limited circumstances:</p>
        <ul>
          <li><strong>Service providers:</strong> With trusted third parties who assist in operating our platform (hosting, analytics, payment processing), subject to confidentiality agreements.</li>
          <li><strong>Organization members:</strong> Information you add to an organization is visible to other authorized members of that organization, in accordance with the permissions set by organization administrators.</li>
          <li><strong>Legal requirements:</strong> When required by law, subpoena, or other legal process, or to protect our rights, safety, or property.</li>
        </ul>
      </MarketingSection>
      <MarketingSection>
        <h2>Cookies and tracking technologies</h2>
        <p>We use cookies and similar technologies for authentication, session management, and remembering your preferences (such as theme settings). We use analytics tools to understand how the platform is used. You can control cookie settings through your browser preferences.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Data security</h2>
        <p>We implement industry-standard security measures including encryption in transit (TLS), secure password hashing, and access controls. While we strive to protect your data, no method of electronic transmission or storage is 100% secure.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Data retention</h2>
        <p>We retain your personal information for as long as your account is active or as needed to provide you services. You may request deletion of your account and associated data by contacting us.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Your rights</h2>
        <p>Depending on your jurisdiction, you may have the right to access, correct, delete, or export your personal data. To exercise these rights, contact us at the address below.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Changes to this policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify you of material changes by posting the updated policy on this page with a revised &ldquo;Last updated&rdquo; date.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Contact us</h2>
        <p>For privacy questions or requests: <a href="mailto:support@equa.cc" style={{ color: '#3292C0' }}>support@equa.cc</a></p>
      </MarketingSection>
    </MarketingPageContainer>
  </MarketingLayout>
  )
}
